module.exports = __webpack_public_path__ + "files/99f17de1106134cf64b441eb19b8297a.png";